import { Injectable } from '@angular/core';
import {
  Event,
  NavigationEnd,
  NavigationStart,
  Router
} from '@angular/router';
import { filter, Observable, shareReplay, tap } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class MojoRouterEventsService {

  private loggingEnabled: boolean = false;

  constructor(
    private readonly router: Router)
  { }

  /**
   * Observable<NavigationEnd>
   *
   * @remarks
   * Subscribe to these router events in constructors (ngOnInit is too late!)
   */
  get NavigationEnd$(): Observable<NavigationEnd> {
    return this.router.events.pipe(
      filter((e: Event) => (e instanceof NavigationEnd)),
      tap((e: NavigationEnd) => this.log(e)),
      filter((e: NavigationEnd) => !this.isIdServerSigninCallbackUrl(e.url)),
      shareReplay()
    );
  }

  /**
   * Observable<NavigationStart>
   *
   * @remarks
   * Subscribe to these router events in constructors (ngOnInit is too late!)
   */
  get NavigationStart$(): Observable<NavigationStart> {
    return this.router.events.pipe(
      filter((e: Event) => (e instanceof NavigationStart)),
      tap((e: NavigationStart) => this.log(e)),
      filter((e: NavigationStart) => !this.isIdServerSigninCallbackUrl(e.url)),
      shareReplay()
    );
  }

  /**
   * Used to ignore id server route changes,
   * typically only 'native' route events need to be acted upon.
   */
  private isIdServerSigninCallbackUrl(url: string): boolean {
    return url.startsWith('/signin-callback');
  }

  private log(e: NavigationStart | NavigationEnd) {
    if (this.loggingEnabled) {
      console.log(`${this.constructor.name} ${e}`);
    }
  }
}
